import moment from 'moment';

export const getDateFormat = (date?: Date, format?: string) => moment(date).format(format);
